<template>
    <transition name="modal-fade">
        <div id="avaiBoatNumModal" class="dibble-modal">
            <div class="modal small-m">
                <div class="modal-dialog modal-form" role="document" style="width: 500px; max-width: 500px">
                    <div class="modal-content">
                        <!-- <div class="modal-header">
                            <h5 class="modal-title" id="ModalLabel">
                                Number of boats available for rental
                            </h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="$emit('close')"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div> -->

                        <div class="modal-header">
                            <p class="title-modal">Number of boats available for rental</p>
                            <button type="button" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                                <img src="../../../assets/images/close-dialog.svg" alt="close-icon">
                            </button>
                        </div>
                        <div class="modal-body form-box mt-3">
                            <div class="form-row">
                                <div class="form-group">
                                    <label for="boat-number">Boat number</label>
                                    <input type="text" v-model="boatNumberData" class="form-control" id="boat-number"
                                        placeholder="Enter boat number" />
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div class="
                                        col-md-12
                                        d-flex
                                        justify-content-between
                                    ">
                                    <button type="button" class="btn btn-4" @click="onSave">
                                        Save
                                    </button>
                                    <button type="button" class="btn btn-4" @click="$emit('close')">
                                        Cancel
                                    </button>
                                </div>
                            </div> -->

                            <div class="d-flex justify-content-center mt-5">
                                <button class="btn-dialog ok-btn" @click="onSave">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import DibbleAPI from "../../../api";
import DibbleJS from "../../../dibble";

export default {
    name: "AvailableBoatNumberModal",
    props: {
        boatNumber: {
            required: true,
            type: [String, Number],
        },
        boatType: {
            required: true,
            type: Number,
        },
    },
    data() {
        return {
            boatNumberData: 0,
        };
    },
    watch: {
        boatNumber: {
            immediate: true,
            handler() {
                this.boatNumberData = this.boatNumber;
            },
        },
    },
    methods: {
        onSave() {
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(
                {
                    request: DibbleAPI.api.setNumOfAvailableBoats,
                    boat_type: this.boatType,
                    num_of_boats: this.boatNumberData,
                },
                (response) => {
                    DibbleJS.hideLoader();
                    if (DibbleAPI.isResponseSuccess(response)) {
                        DibbleJS.toastSuccessMessage(response.message);
                        this.$emit("saved");
                    } else {
                        DibbleJS.toastErrorMessage(response.message);
                    }
                }
            );
        },
    },
};
</script>

<style>

</style>
